import type { StakeholderRelation } from "../../hooks";

/**
 * 関係性をCSVに書き出す。
 *
 * 入稿（`parseStakeholderRelations`）の4列を先頭に同じ順で並べる。入稿は4列かつ
 * ヘッダーなしを要求するので、このまま入稿し直せるわけではないが、CS が手元で
 * 不要な列と行を落として使い回せる形にしておく。
 */
export function buildStakeholderRelationsCsv(
  relations: readonly StakeholderRelation[],
): string {
  const header = [
    "受け取る人のメール",
    "受け取る人の氏名",
    "回答者のメール",
    "回答者の氏名",
    "インタビュー設定",
    "回答",
  ];
  const rows = relations.map((relation) => [
    relation.recipientEmail,
    relation.recipientName,
    relation.respondentEmail,
    relation.respondentName,
    relation.stakeholderSettingName,
    relation.hasAnswer ? "回答済み" : "未回答",
  ]);
  return [header, ...rows]
    .map((row) => row.map(escapeCell).join(","))
    .join("\n");
}

/** カンマ・改行・引用符を含むセルを壊さないようにする */
function escapeCell(value: string): string {
  if (!/[",\n\r]/.test(value)) return value;
  return `"${value.replace(/"/g, '""')}"`;
}
